var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeraConfirm',_vm._g(_vm._b({},'HeraConfirm',{
    title: _vm.title,
    cancelButtonText: _vm.cancelButtonText,
    confirmButtonText: _vm.confirmButtonText,
    isLoading: _vm.isLoading,
  },false),_vm.$listeners),[_c('TextBlock',{staticClass:"text-left",attrs:{"tag":"p","variant":"secondary"}},[_vm._v("\n    "+_vm._s(_vm.$t(
        '_web_tournament_pause_modal-text',
        "Changing tournament status allows you to edit brackets on 'Publish Brackets' and then republish your tournament"
      ))+"\n  ")]),_c('TextBlock',{staticClass:"text-left",attrs:{"tag":"p","variant":"secondary"}},[_vm._v("\n    "+_vm._s(_vm.$t('_web_tournament_pause_modal-notes-text', 'Please note:'))),_c('br'),_vm._v("\n    "+_vm._s(_vm.$t(
        '_web_tournament_pause_modal-text-note-1',
        'Resetting brackets with already completed matches will erase existing results. There is no undo.'
      ))+"\n  ")]),_c('TextBlock',{staticClass:"text-left",attrs:{"tag":"p","variant":"secondary"}},[_vm._v(_vm._s(_vm.$t(
      '_web_tournament_pause_modal-text-note-2',
      'Once brackets are reset, matches can be edited manually.'
    )))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }